<template>
	<div class="content-wrap">
		<transition name="fade-block" mode="out-in">
			<keep-alive>
				<IntroForm v-show="introActive" />
			</keep-alive>
		</transition>
		<transition name="fade-block" mode="out-in">
			<StepForm v-if="stepActive" />
		</transition>
	</div>
</template>

<script>
	import StepForm from './StepForm'
	import IntroForm from './IntroForm'
	import { mapGetters } from 'vuex'

	export default {
		name: 'app-content',
		components: {
			StepForm,
			IntroForm
		},
		computed: {
			...mapGetters(['introActive', 'stepActive'])
		}
	}
</script>

<style lang="scss">
	@import "@/styles/tutorial_editor/globals";
	$content-padding: 50px;
	.content-wrap {
		padding: $content-padding / 2;
	}
</style>
